export default {
  state: {
    onDuty: {
      drivers: [],
      loading: false,
      pageNum: 1,
      pageSize: 20,
      totalPages: 0,
      noDriversFound: false,
      order: 'ID',
      asc: true
    },
    offDuty: {
      drivers: [],
      loading: false,
      pageNum: 1,
      pageSize: 20,
      totalPages: 0,
      noDriversFound: false,
      order: 'ID',
      asc: true
    },
    staging: {
      drivers: [],
      loading: false,
      pageNum: 1,
      pageSize: 20,
      totalPages: 0,
      noDriversFound: false,
      order: 'ID',
      asc: true
    },
    driverListFilters: {
      search: '',
      serviceTypes: ['shared', 'opoli', 'black', 'suv', 'shuttle']
    },
    driverListTabIndex: 0,
    driverInPopup: {
      id: null,
      phone: null,
      email: null,
      firstName: null,
      lastName: null,
      photoUrl: null,
      vehicle: {
        name: null,
        licensePlate: null,
        photoUrl: null
      }
    },
    driverInPopupRoute: {
      path: [],
      distance: null, // in miles
      duration: null // in minutes
    },
    loadingDrivers: false,
    selectedDriver: null,
    serviceCount: {
      shared: 0,
      opoli: 0,
      black: 0,
      suv: 0,
      shuttle: 0
    },
    serviceFilter: {
      show: false,
      loading: false,
      list: []
    },
    totalDrivers: {
      onDuty: 0,
      staging: 0,
      offDuty: 0
    },
    reloadDrivers: false,
    driverPanelOpen: false,
    tabActive: {
      rsvp: 'dispatch',
      driver: 'onDuty'
    },
    noSector: false
  },
  mutations: {
    // OnlineDrivers
    setOnDutyDrivers (state, drivers) { state.onDuty.drivers = drivers },
    setOnDutyLoading (state, value) { state.onDuty.loading = value },
    setOnDutyPageNumber (state, value) { state.onDuty.pageNum = value },
    setOnDutyTotalPages (state, total) { state.onDuty.totalPages = Math.ceil(total / state.onDuty.pageSize) },
    addToOnDutyDrivers (state, driver) { state.onDuty.drivers.unshift(driver) },
    setOnDutyNoDriversFound (state, value) { state.onDuty.noDriversFound = value },
    setOnDutySorting (state, value) {
      state.onDuty.order = value.order
      state.onDuty.asc = value.asc
    },
    removeFromOnDutyDrivers (state, driverId) {
      if (state.onDuty.drivers.length <= 0) {
        state.onDuty.pageNum = 1
        state.onDuty.totalPages = 0
        return
      }
      let drivers = state.onDuty.drivers
      state.onDuty.drivers = drivers.filter(driver => driver.id !== driverId)
      if (state.onDuty.drivers.length <= 0) {
        state.onDuty.pageNum = 1
        state.onDuty.totalPages = 0
      }
    },
    // Offline Drivers
    setOffDutyDrivers (state, drivers) { state.offDuty.drivers = drivers },
    setOffDutyLoading (state, value) { state.offDuty.loading = value },
    setOffDutyPageNumber (state, value) { state.offDuty.pageNum = value },
    setOffDutyTotalPages (state, total) { state.offDuty.totalPages = Math.ceil(total / state.offDuty.pageSize) },
    addToOffDutyDrivers (state, driver) { state.offDuty.drivers.unshift(driver) },
    setOffDutyNoDriversFound (state, value) { state.offDuty.noDriversFound = value },
    setOffDutySorting (state, value) {
      state.offDuty.order = value.order
      state.offDuty.asc = value.asc
    },
    removeFromOffDutyDrivers (state, driverId) {
      if (state.offDuty.drivers.length <= 0) {
        state.offDuty.pageNum = 1
        state.offDuty.totalPages = 0
        return
      }
      let drivers = state.offDuty.drivers
      state.offDuty.drivers = drivers.filter(driver => driver.id !== driverId)
      if (state.offDuty.drivers.length <= 0) {
        state.offDuty.pageNum = 1
        state.offDuty.totalPages = 0
      }
    },

    // Staging Drivers
    setStagingDrivers (state, drivers) {
      state.staging.drivers = drivers
      if (state.staging.drivers.length <= 0) {
        state.staging.pageNum = 1
        state.staging.totalPages = 0
        state.staging.order = 'ID'
        state.staging.asc = true
      }
    },
    setStagingLoading (state, value) { state.staging.loading = value },
    setStagingPageNumber (state, value) { state.staging.pageNum = value },
    setStagingTotalPages (state, total) { state.staging.totalPages = Math.ceil(total / state.staging.pageSize) },
    addToStagingDrivers (state, driver) { state.staging.drivers.unshift(driver) },
    setStagingNoDriversFound (state, value) { state.staging.noDriversFound = value },
    setStagingSorting (state, value) {
      state.staging.order = value.order
      state.staging.asc = value.asc
    },
    removeFromStagingDrivers (state, driverId) {
      if (state.staging.drivers.length <= 0) {
        state.staging.pageNum = 1
        state.staging.totalPages = 0
        return
      }
      let drivers = state.staging.drivers
      state.staging.drivers = drivers.filter(driver => driver.id !== driverId)
      if (state.staging.drivers.length <= 0) {
        state.staging.pageNum = 1
        state.staging.totalPages = 0
        state.staging.order = 'ID'
        state.staging.asc = true
      }
    },
    resetStagingDriver (state) {
      state.staging = {
        drivers: [],
        loading: false,
        pageNum: 1,
        pageSize: 20,
        totalPages: 0,
        noDriversFound: false,
        order: 'ID',
        asc: true
      }
    },

    // Driver Tab
    setDriverListTabIndex (state, value) { state.driverListTabIndex = value },

    // Filters
    setDriverListSearchFilter (state, value) { state.driverListFilters.search = value },
    setDriverListServiceTypeFilter (state, value) { state.driverListFilters.serviceTypes = value },

    // Driver in Map Popup
    showDriverInPopup (state, driver) { state.driverInPopup = driver },
    clearDriverPopup (state) {
      state.driverInPopup = {
        id: null,
        phone: null,
        email: null,
        firstName: null,
        lastName: null,
        photoUrl: null,
        vehicle: {
          name: null,
          licensePlate: null,
          photoUrl: null
        }
      }
      state.driverInPopupRoute = {
        path: [],
        distance: null,
        duration: null
      }
    },
    setDriverInPopupRoute (state, value) { state.driverInPopupRoute = value },

    // Selected driver via checkbox
    setSelectedDriver (state, value) { state.selectedDriver = value },
    setServiceCount (state, value) { state.serviceCount = value },
    setServiceFilterShow (state, value) { state.serviceFilter.show = value },
    setServiceFilterLoading (state, value) { state.serviceFilter.loading = value },
    toggleServiceFilterList (state, value) {
      let index = state.serviceFilter.list.indexOf(value)
      if (index > -1) {
        state.serviceFilter.list.splice(index, 1)
      } else {
        state.serviceFilter.list.push(value)
      }
    },
    setDriversTotal (state, data) { state.totalDrivers[data.field] = data.value },
    setReloadDrivers (state, value) { state.reloadDrivers = value },
    setDriverPanelOpen (state, value) { state.driverPanelOpen = value },
    setTabActiveData (state, data) {
      for (let field in data) {
        state.tabActive[field] = data[field]
      }
    },
    setNoSector (state, value) { state.noSector = value }
  },
  sharedMutations: [
    'dispatch/setOnDutyDrivers',
    'dispatch/setOffDutyDrivers',
    'dispatch/showDriverInPopup',
    'dispatch/clearDriverPopup',
    'dispatch/setDriverInPopupRoute',
    'dispatch/setSelectedDriver'
  ]
}



// WEBPACK FOOTER //
// ./src/store/dispatch/dispatch-drivers.js